import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Stadium } from "@/modules/stadium/entity";
import { Team } from "@/modules/team/entity";
import Foundation from "@/modules/stadium/components/Foundation.vue";
import TerraceComponent from "@/modules/stadium/components/Terrace.vue";
import { app } from "@/di";
import EntranceFeeChanger from "@/modules/stadium/services/EntranceFeeChanger";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const stadium = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const team = await Team.current();
      stadium.value = await Stadium.createQueryBuilder('stadium').innerJoinAndSelect('stadium.terraces', 'terrace').innerJoin('stadium.team', 'team').where('team.id = :id', {
        id: team.id
      }).getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    const onChangePrice = (terrace, fee) => {
      app.get(EntranceFeeChanger).set(terrace, fee);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('stadium')), 1)]),
        default: _withCtx(() => [_createVNode(Foundation, {
          stadium: stadium.value,
          class: "my-2"
        }, null, 8, ["stadium"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stadium.value.terraces, terrace => {
          return _openBlock(), _createBlock(TerraceComponent, {
            key: terrace.id,
            terrace: terrace,
            class: "mb-2",
            onEntranceFeeChanged: $event => onChangePrice(terrace, $event)
          }, null, 8, ["terrace", "onEntranceFeeChanged"]);
        }), 128))]),
        _: 1
      });
    };
  }
});